import 'react-toggle/style.css';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import IIntersystemsComponents from 'src/ServerEntities/IIntersystemsComponents';
import IIntersystemsComponent from 'src/ServerEntities/IIntersystemsComponent';

const OuterContainer = styled.div`
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
`;

const InnerContainer = styled.div`
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
`;

const TitleBar = styled.div`
    border-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    color: #FFF;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
    cursor: pointer;
`;

const IntersystemStateBubble = styled.div`
    border-radius: 15px;
    padding: 1px;
    padding-bottom: 2px;
    min-width: 70px;
    text-align: center;
    font-size: 0.8em;
    font-weight: bold;
        &.ERROR {
          background-color: #F00;  /* Red background */
          color: #FFF;  /* White text */
        }
        &.RETRY  {
            background-color:rgb(231, 139, 0);
        }
        &.DISABLED  {
            background-color: #b7bec2;
        }
        &.INACTIVE  {
           background-color: #2DF6C0;
        }    
        &.OK  {
            background-color:rgb(0, 232, 0);
        }
`;


const Footer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 5px
`;

const ComponentContainer = styled.div`
   margin-top: 5px;
   margin-bottom: 5px
`;

const ComponentHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 5px;
    font-weight: bold;
    justify-content: space-evenly
`;

const BarItem = styled.div`
    &.ERROR {
      color: #F00;
    }
    &.RETRY  {
      color:rgb(231, 139, 0);
    }
    &.DISABLED  {
      color: #b7bec2;
    }
    &.INACTIVE  {
      color: #2DF6C0;
    }    
    &.OK  {
      color:rgb(0, 232, 0);
    }
`;

interface IProps {
    data: IIntersystemsComponents;
};

const renderIntersystemState = (state: string) => {
    switch(state.toLocaleUpperCase()) {
         case "ERROR":   return <IntersystemStateBubble className={state}>ERROR</IntersystemStateBubble>
         case "RETRY": return <IntersystemStateBubble className={state}>RETRY</IntersystemStateBubble>
         case "DISABLED": return <IntersystemStateBubble className={state}>DISABLED</IntersystemStateBubble>
         case "INACTIVE": return <IntersystemStateBubble className={state}>INACTIVE</IntersystemStateBubble>
         case "OK": return <IntersystemStateBubble className={state}>OK</IntersystemStateBubble>
    }
    return null;
};

const IntersystemsComponentPanel = (props: IProps) => {
    const { data } = props;
    const navigate = useNavigate();

    if (!data) {
        return <div>Loading component data...</div>;
    }

    const handleClick = () => {
        navigate('/Ram/Intersystems Components');
    };

    const renderComponent = (name: string, components: IIntersystemsComponent[]) => {
        const total = components.length;
        const errorCount = components.filter(c => c.state.toLocaleUpperCase() === "ERROR").length;
        const warningCount = components.filter(c => c.state.toLocaleUpperCase() === "RETRY").length;
        const disabledCount = components.filter(c => c.state.toLocaleUpperCase() === "DISABLED").length;
        const queueingCount = components.filter(c => c.state.toLocaleUpperCase() === "INACTIVE").length;
        const runningCount = components.filter(c => c.state.toLocaleUpperCase() === "OK").length;
        const errorWidth = (errorCount / total) * 100;
        const warningWidth = (warningCount / total) * 100;
        const disabledWidth = (disabledCount / total) * 100;
        const queueingWidth = (queueingCount / total) * 100;
        const runningWidth = (runningCount / total) * 100;

        return (
            <ComponentContainer>
                <ComponentHeader>
                    <div style={{ width: "50%" }}>{name}</div>
                    <div style={{ width: "10%" }}>{total}</div>
                    <BarItem className='ERROR' style={{ width: "10%" }}>{errorCount}</BarItem>
                    <BarItem className='RETRY' style={{ width: "10%" }}>{warningCount}</BarItem>
                    <BarItem className='DISABLED' style={{ width: "10%" }}>{disabledCount}</BarItem>
                    <BarItem className='INACTIVE' style={{ width: "10%" }}>{warningCount}</BarItem>
                    <BarItem className='OK' style={{ width: "10%" }}>{runningCount}</BarItem>
                </ComponentHeader>

                <div style={{ display: 'flex', width: '100%', height: '20px', border: '0px solid black', borderRadius: '10px', overflow: 'hidden' }}>
                    <div style={{ width: `${errorWidth}%`, backgroundColor: 'red', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}></div>
                    <div style={{ width: `${warningWidth}%`, backgroundColor: '#e78b00' }}></div>
                    <div style={{ width: `${disabledWidth}%`, backgroundColor: '#B7BEC2' }}></div>
                    <div style={{ width: `${queueingWidth}%`, backgroundColor: '#2DF6C0' }}></div>
                    <div style={{ width: `${runningWidth}%`, backgroundColor: '#5CEA5A', borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }}></div>
                </div>
            </ComponentContainer >
        );
    };

    return <OuterContainer>
        <TitleBar onClick={handleClick}>Components</TitleBar>
        <InnerContainer>
            {renderComponent("Operations", data.operations ?? [])}
            {renderComponent("Processes", data.processes ?? [])}
            {renderComponent("Services", data.services ?? [])}
       </InnerContainer>
        <Footer>
            {renderIntersystemState("ERROR")}
            {renderIntersystemState("RETRY")}
            {renderIntersystemState("DISABLED")}
            {renderIntersystemState("INACTIVE")}
            {renderIntersystemState("OK")}
        </Footer>
    </OuterContainer>;
};

export default IntersystemsComponentPanel;
